import { render } from "./Privacy.vue?vue&type=template&id=5cbe56de&scoped=true"
const script = {}

import "./Privacy.vue?vue&type=style&index=0&id=5cbe56de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\EFRENBP\\Desktop\\Projects\\2022\\03-Landing referidos\\AM-referidos\\am-referrals router\\am-referrals\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cbe56de"]])

export default __exports__